import { Component } from "react";
// import { isStyledComponent } from "styled-components";
/*
class RowMapsGoogle extends Component{
  constructor(props){
    super(props)
  }

  render(){
    return(
        <>
          <div style={this.props.style} id={this.props.id} className={"m-2"+this.props.widthColumn} style={{width: "100%", height:"300px"}} />
        </>
    )
  }
}
*/
class MapGoogle extends Component {

  state = {
    isIdArray : false
  }


    constructor(props) {
      super(props); 
    }
    
  
    onScriptLoad = () => {
      if(this.state.isIdArray){
        this.props.id.forEach(element => {
          let id = element[0]
          let nombreMapa = element[1]
          let map = new window.google.maps.Map(document.getElementById(id),this.props.options);
          map.nombreMapa = nombreMapa
        
          if(typeof this.props.iconos !== 'undefined'){
            map.iconos = this.props.iconos[id]
          }
         

          if(typeof this.props.ventanasIncrustadas !== 'undefined'){
            let ventanasIncrustadas = this.props.ventanasIncrustadas
            
            ventanasIncrustadas.forEach(el => {
              
              if(id === el[0]){
                for (let i = 1; i < el.length; i++) {
                  this.crearVentanaIncrustada(el[i], map)
                }
              }
              
            });
          }
          this.props.onMapLoad(this.props.referencia, map, nombreMapa)

        });
      }
      else{
        const map = new window.google.maps.Map(document.getElementById(this.props.id), this.props.options);
        this.props.onMapLoad(map)
      } 
    }
    
    crearVentanaIncrustada(func, map){
      func(map, this.props.referencia)
    }

    
  
    componentDidMount() {
      this.setState({isIdArray : Array.isArray(this.props.id)})

      if (!window.google) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = `https://maps.google.com/maps/api/js?key=AIzaSyC5_bKVZPjdddZkv0IJeGPXPl8FNZOE-4M`;
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
        // Below is important. 
        //We cannot access google.maps until it's finished loading
        s.addEventListener('load', e => {
          this.onScriptLoad()
        })
      } else {
        this.onScriptLoad()
      }
    }

    

    crearListaMapas(){
      let ListaMapas = []
      let ColumnMapas = []
      if(this.state.isIdArray){
        // let size = this.props.id.length
        //let ancho = size == 1 ? "100%" : "50%"

        /*this.props.id.forEach((element, index) => {
          ListaMapas[index] = <div className="columns">
            <div style={this.props.style} id={element[0]} className="m-2 column" style={{height:"350px"}} />
          </div>
        });*/

        
        this.props.id.forEach((element, index) => {
        // ColumnMapas[index] = <div style={this.props.style} id={element[0]} className="m-2" style={{width: "100%", height:"300px"}} />
        ColumnMapas[index] = element[0]
        });


        for (let index = 0; index < Math.ceil( this.props.id.length/2); index++) {
          if(typeof ColumnMapas[index*2 + 1] !== 'undefined' ){
            //alert("si es ondefained")
          }
          ListaMapas[index] = <div ke={ index } className = "columns is-justify-content-center mb-5 is-desktop">
            {typeof ColumnMapas[index*2 + 1] !== 'undefined' ? 
            <>
            <div style={this.props.style ? this.props.style  : {width: "100%", height:"300px"}} id={ColumnMapas[index*2]} className=" column m-2" />
            <div style={this.props.style ? this.props.style  : {width: "100%", height:"300px"}} id={ColumnMapas[index*2+1]} className=" column m-2"/>
            </>
            : 
            <>
            <div style={this.props.style ? this.props.style : {height:"300px"}} id={ColumnMapas[index*2]} className=" column is-half-desktop m-2" />
            </> 
            }

          </div>
        }

        

        
      }
      else{
        ListaMapas[0] = <div key={ 0 } style={this.props.style} id={this.props.id} />
      }

      
      
      return ListaMapas
    }


  
    render() {
      return (
        <div>
          {this.crearListaMapas()}
        </div>
      );
    }
}

export default MapGoogle
